module.exports = __webpack_public_path__ + "img/symbol_8.06b585cf.png";